import {asset} from 'imba';
import url from './P.svg';

export default /* @__PURE__ */ asset({
	url: url,
	type: 'svg',
	meta: {"attributes":{"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"},"flags":[],"content":"\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14 12C14 10.8954 14.8954 10 16 10L26 10C30.4183 10 34 13.5817 34 18C34 22.4183 30.4183 26 26 26L18 26L18 36C18 37.1046 17.1046 38 16 38C14.8954 38 14 37.1046 14 36L14 12ZM18 22L26 22C28.2091 22 30 20.2091 30 18C30 15.7909 28.2091 14 26 14L18 14L18 22Z\" fill=\"#333333\"/>\n\n"},
	toString: function(){ return this.url;}
})